import { render } from "./pdfcupomcompraView.vue?vue&type=template&id=65b9b78a"
import script from "./pdfcupomcompraView.vue?vue&type=script&lang=js"
export * from "./pdfcupomcompraView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__